export const IS_PRODUCTION = process.NODE_ENV === "production";
export const IS_DEVELOPMENT = process.NODE_ENV === "development";

export const app_config = {
	bucketCount: 10,
	projectIds: { Cigarette: 1598 },
	//   projectIds: { Cigarette: 1643, Vapes: 1642, Cigars: 1641 },
};
